export default {
    items: [
        {
            name: 'Home',
            url: '/home',
            icon: 'icon-home',
            level: 0,
        },
        {
            name: 'Beheer',
            icon: 'icon-puzzle',
            level: 5,
            children: [
                {
                    name: 'Bedrijven',
                    url: '/beheer/bedrijf',
                    icon: 'icon-flag',
                    level: 5,
                },
                {
                    name: 'Accounts',
                    url: '/beheer/account',
                    icon: 'icon-user',
                    level: 7,
                },
                {
                    name: 'Afdelingen',
                    url: '/beheer/afdeling',
                    icon: 'icon-lock',
                    level: 5,
                },
                {
                    name: 'Teelten',
                    url: '/beheer/afdelingteelt',
                    icon: 'icon-puzzle',
                    level: 5,
                },
                {
                    name: 'Glastypes',
                    url: '/beheer/glastype',
                    icon: 'icon-picture',
                    level: 7,
                },
                {
                    name: 'Belichtingssoorten',
                    url: '/beheer/soortbelichting',
                    icon: 'icon-bulb',
                    level: 7,
                },
                {
                    name: 'Teeltsoorten',
                    url: '/beheer/teelt',
                    icon: 'icon-globe',
                    level: 7,
                },
            ],
        },
        {
            name: 'Weer',
            url: '/weer',
            icon: 'icon-umbrella',
            level: 3,
            children: [
                {
                    name: 'Voorspelling',
                    url: '/weer/voorspelling',
                    icon: 'icon-control-forward',
                    level: 3,
                },
                {
                    name: 'Weerstation',
                    url: '/weer/weerstation',
                    icon: 'icon-cloud-download',
                    level: 3,
                },
            ],
        },
    ],
};



// WEBPACK FOOTER //
// ./src/_nav.js